import { faChevronDown, faChevronUp, faWrench } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import StatusBadge from 'src/components/ui/StatusBadge';

import InstructionAnswer from './InstructionAnswer';

const AnswersPreviewCard = ({
  requirement,
  isInstance,
  instructions,
  values,
  files,
  skipped,
  onViewFile,
  defaultOpen,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className='mnt-report'>
      <div
        className='mnt-report__head mnt-report__head--tap'
        role='button'
        tabIndex={0}
        onClick={() => setOpen(prev => !prev)}
        onKeyDown={event => {
          if (event.key === 'Enter' || event.key === ' ') setOpen(prev => !prev);
        }}
      >
        <span
          className={classNames(
            'mnt-scope-tile',
            'mnt-scope-tile--sm',
            isInstance ? 'mnt-scope-tile--instance' : 'mnt-scope-tile--type'
          )}
        >
          <FontAwesomeIcon icon={faWrench} />
        </span>
        <div className='mnt-report__headmain'>
          <span className='mnt-report__name'>{requirement.name}</span>
        </div>
        {skipped ? (
          <StatusBadge size='sm' uppercase={false} variant='default'>
            Skipped
          </StatusBadge>
        ) : (
          <StatusBadge dot size='sm' uppercase={false} variant='success'>
            Complete
          </StatusBadge>
        )}
        <FontAwesomeIcon icon={open ? faChevronUp : faChevronDown} className='mnt-report__chev' />
      </div>

      {open &&
        (skipped ? (
          <div className='mnt-report__skip'>Skipped. No reports were recorded.</div>
        ) : (
          <div className='mnt-report__rows'>
            {instructions.map(instruction => (
              <div key={instruction.uuid || instruction.uri} className='mnt-report__row'>
                <span className='mnt-report__q'>{instruction.question}</span>
                <span className='mnt-report__a'>
                  <InstructionAnswer
                    instruction={instruction}
                    value={values[instruction.uuid]}
                    file={files[instruction.uuid]}
                    onViewFile={onViewFile}
                  />
                </span>
              </div>
            ))}
            {!instructions.length && (
              <div className='mnt-report__empty'>No checklist steps on this requirement.</div>
            )}
          </div>
        ))}
    </div>
  );
};

AnswersPreviewCard.propTypes = {
  requirement: PropTypes.object.isRequired,
  isInstance: PropTypes.bool,
  instructions: PropTypes.array,
  values: PropTypes.object,
  files: PropTypes.object,
  skipped: PropTypes.bool,
  onViewFile: PropTypes.func,
  defaultOpen: PropTypes.bool,
};

AnswersPreviewCard.defaultProps = {
  isInstance: true,
  instructions: [],
  values: {},
  files: {},
  skipped: false,
  onViewFile: null,
  defaultOpen: false,
};

export default AnswersPreviewCard;
